var map = {
	"./a": 2,
	"./a.js": 2,
	"./c": 6,
	"./c.js": 6,
	"./circular": 3,
	"./circular.js": 3,
	"./constructor": 1,
	"./constructor.js": 1,
	"./d": 7,
	"./d.js": 7,
	"./templates/a": 10,
	"./templates/a.js": 10,
	"./templates/b": 11,
	"./templates/b.js": 11,
	"./templates/c": 12,
	"./templates/c.js": 12,
	"./warnings": 13,
	"./warnings.js": 13
};
function webpackContext(req) {
	return require(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
